export default {
  // baseUrl:"http://localhost:8080/hc-admin"
  baseUrl: "https://hongmai.vip/hc-admin",
  // baseUrl:"https://8.153.206.116:8081/hc-admin",
  // baseUrl:"https://hongmai.vip/hc-admin",
  // baseUrl:"http://192.168.1.11:8080/hc-admin"
};
